/* Mr. Airco – mobiele helpers, filteren zonder herladen, account-status */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 720px)');

  /* ---------- filterpaneel (mobiel) ---------- */
  function setPanel(f, shade, on) {
    f.classList.toggle('is-open', on); shade.classList.toggle('is-open', on);
    document.documentElement.classList.toggle('mra-noscroll', on);
  }
  function initFilters(reopen) {
    var f = document.querySelector('.mra-coll > .mra-filters'); if (!f || f.__mra) return; f.__mra = true;
    var active = f.querySelectorAll('.mra-fopt.is-active').length;
    var bar = document.createElement('div'); bar.className = 'mra-mfbar';
    bar.innerHTML = '<button type="button" data-mra-fopen><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 6h16M7 12h10M10 18h4"/></svg>Filteren' + (active ? ' <b>' + active + '</b>' : '') + '</button>';
    f.parentNode.insertBefore(bar, f.parentNode.firstChild);
    var shade = document.querySelector('.mra-fshade');
    if (!shade) { shade = document.createElement('div'); shade.className = 'mra-fshade'; document.body.appendChild(shade); }
    var cnt = document.querySelector('.mra-toolbar__chips strong'); var n = cnt ? cnt.textContent.trim() : '';
    var x = document.createElement('button'); x.type = 'button'; x.className = 'mra-filters__x'; x.setAttribute('aria-label', 'Filters sluiten');
    x.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var top = f.querySelector('.mra-filters__top'); if (top) top.appendChild(x);
    var foot = document.createElement('div'); foot.className = 'mra-filters__foot';
    foot.innerHTML = '<button type="button" class="mra-btn mra-btn--blue">Bekijk ' + (n || 'resultaten') + '</button>'; f.appendChild(foot);
    bar.querySelector('[data-mra-fopen]').addEventListener('click', function () { setPanel(f, shade, true); });
    shade.onclick = function () { setPanel(f, shade, false); };
    foot.querySelector('button').addEventListener('click', function () { setPanel(f, shade, false); });
    x.addEventListener('click', function () { setPanel(f, shade, false); });
    if (reopen && mq.matches) { f.style.transition = 'none'; setPanel(f, shade, true); requestAnimationFrame(function () { f.style.transition = ''; }); }
    else { shade.classList.remove('is-open'); document.documentElement.classList.remove('mra-noscroll'); }
  }
  function initDesc() {
    var d = document.querySelector('.mra-chead__desc'); if (!d || d.__mra) return; d.__mra = true;
    if (window.innerWidth > 720) return;
    requestAnimationFrame(function () {
      if (d.scrollHeight <= d.clientHeight + 4) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mra-chead__more'; b.textContent = 'Lees meer';
      b.addEventListener('click', function () { var o = d.classList.toggle('is-open'); b.textContent = o ? 'Minder tonen' : 'Lees meer'; });
      d.parentNode.insertBefore(b, d.nextSibling);
    });
  }

  /* ---------- filteren zonder herladen (Section Rendering API) ---------- */
  function collSection() { var c = document.querySelector('.mra-coll'); return c && c.closest('[id^="shopify-section-"]'); }
  var busy = null;
  function go(url, push, fallback) {
    var sec = collSection(); if (!sec) { location.href = url; return; }
    var id = sec.id.replace('shopify-section-', '');
    var u = new URL(url, location.origin); u.hash = '';
    var fetchUrl = new URL(u.toString()); fetchUrl.searchParams.set('sections', id);
    var f = sec.querySelector('.mra-filters'); var wasOpen = f && f.classList.contains('is-open');
    var openDetails = [].map.call(sec.querySelectorAll('.mra-filters details'), function (d) { return d.open; });
    sec.classList.add('mra-loading');
    if (busy) busy.abort(); busy = new AbortController();
    fetch(fetchUrl.toString(), { signal: busy.signal })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[id]; if (!html) { location.href = u.toString(); return; }
        // Filters staan (nog) op EN-logica: meerdere waarden binnen één filter geven 0 resultaten.
        // Dan valt de bundel terug op de waarde met de meeste producten.
        if (fallback && /class="mra-empty"/.test(html)) { busy = null; go(fallback, push); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.shopify-section') || doc.body;
        sec.innerHTML = fresh.innerHTML;
        [].forEach.call(sec.querySelectorAll('.mra-filters details'), function (d, i) { if (openDetails[i]) d.open = true; });
        if (push !== false) history.pushState({ mraColl: 1 }, '', u.pathname + u.search);
        sec.classList.remove('mra-loading');
        initFilters(wasOpen); initDesc();
        if (window.mraApplyBtw) window.mraApplyBtw();
        document.dispatchEvent(new CustomEvent('mra:collection-updated'));
      })
      .catch(function (e) { if (e.name !== 'AbortError') location.href = u.toString(); });
  }
  window.mraCollGo = go;
  function bucketUrl(a) {
    var param = a.getAttribute('data-param');
    var vals = (a.getAttribute('data-values') || '').split('||').filter(Boolean);
    var u = new URL(location.href); var cur = u.searchParams.getAll(param);
    var on = vals.some(function (v) { return cur.indexOf(v) > -1; });
    u.searchParams.delete(param);
    cur.filter(function (v) { return vals.indexOf(v) === -1; }).forEach(function (v) { u.searchParams.append(param, v); });
    var fb = null;
    if (!on) {
      vals.forEach(function (v) { u.searchParams.append(param, v); });
      var best = a.getAttribute('data-best');
      if (vals.length > 1 && best) { var f = new URL(u.toString()); var keep = f.searchParams.getAll(param).filter(function (v) { return vals.indexOf(v) === -1; }); f.searchParams.delete(param); keep.forEach(function (v) { f.searchParams.append(param, v); }); f.searchParams.append(param, best); f.searchParams.delete('page'); fb = f.toString(); }
    }
    u.searchParams.delete('page');
    return { url: u.toString(), fb: fb };
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var sec = collSection(); if (!sec || !sec.contains(e.target)) return;
    var b = e.target.closest('[data-mra-fb]');
    if (b) { e.preventDefault(); var bu = bucketUrl(b); go(bu.url, true, bu.fb); return; }
    var a = e.target.closest('a.mra-fopt, a.mra-brandtile, a.mra-kwtile, a.mra-activechip, .mra-pagination a, .mra-filters__top a');
    if (!a || !a.href) return;
    e.preventDefault();
    var toTop = a.closest('.mra-pagination');
    go(a.href);
    if (toTop) { var c = sec.querySelector('.mra-coll'); if (c) window.scrollTo({ top: c.getBoundingClientRect().top + scrollY - 100, behavior: 'smooth' }); }
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-mra-sort]'); if (!s || !collSection()) return;
    e.stopImmediatePropagation();
    var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); go(u.toString());
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target; var sec = collSection(); if (!sec || !sec.contains(form) || !form.closest('.mra-filters')) return;
    e.preventDefault();
    var u = new URL(form.getAttribute('action') || location.pathname, location.origin);
    new FormData(form).forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
    go(u.toString());
  });
  window.addEventListener('popstate', function () { if (collSection()) go(location.href, false); });

  /* ---------- ingelogd: duidelijk zichtbaar ---------- */
  function initAcct() {
    var a = document.querySelector('.mra-acct.is-in'); if (!a || a.__mra) return; a.__mra = true;
    var name = (a.getAttribute('title') || '').replace(/^Ingelogd als\s*/i, '').split(/[\s@]/)[0];
    var lab = document.createElement('span'); lab.className = 'mra-acct-label';
    lab.innerHTML = '<small>Ingelogd</small><strong>' + (name ? 'Hoi ' + name.replace(/[<>&"]/g, '') : 'Mijn account') + '</strong>';
    a.insertAdjacentElement('afterend', lab);
    lab.addEventListener('click', function () { location.href = a.href; });
  }

  function init() { initFilters(); initDesc(); initAcct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
